import React from 'react';
import formatCurrency from '@tcs/common/utils/formatCurrency';
import TwoLineCell from '@tcs/client-portal-common/components/molecules/Table/cells/TwoLineCell';

interface InvestmentValueCellProps {
  value: number;
  numberOfUnits: number;
}

const InvestmentValueCell = ({
  value,
  numberOfUnits,
}: InvestmentValueCellProps) => {
  return (
    <TwoLineCell
      primary={formatCurrency(value)}
      secondary={
        numberOfUnits && `${formatCurrency(value / numberOfUnits)}/unit`
      }
      align="left"
      isPrivate // investment values are always hidden in logrocket
    />
  );
};

export default InvestmentValueCell;
